import type { RuntimeConfig } from 'nuxt/schema';
import markerImage from '~~/common/assets/images/auchan_A_marker.svg';

export function getOSMConfig (config: RuntimeConfig) {
  const osmFullUrl = config.public.osmFullUrl;

  return {
    tileLayer: [
      osmFullUrl,
      {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
    ],
    icon: {
      iconUrl: markerImage,
      iconSize: [52, 64],
      iconAnchor: [26, 64],
      popupAnchor: [0, -64],
    },
  };
}
